export default (params) => ({
  trigger: {
    name: 'feedback_element.confirm_feedback',
    params: params,
  },
  config: {
    schema: {
      status: {
        enum: [
          'success',
          'failure',
          'no_delivery',
        ],
      },
      sub_feature: {
        enum: [
          'ar',
          'after_order',
          'trade-in',
          'return',
          'other',
          'advice',
        ],
      },
    },
    event: {
      name: 'confirm',
    },
  },
});
